<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('tuition_assistance_re_evaluation_request')"
                        :isFilter="false">
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('tuition_assistance_re_evaluation_request')"
                              :isFilter="false">
                </HeaderMobile>
            </template>
            <b-tabs content-class="py-5 position-relative" v-model="tabIndex">
                <div class="tabs-bottom-line"></div>
                <b-tab>
                    <div class="d-flex justify-content-end mb-2">
                        <b-button
                            v-if="isStudent && checkPermission('tuitionassistancereevaluation_store')"
                            variant="primary"
                            class="mr-2"
                            @click="$router.push('/tuition/assistance/request')"
                        >
                            {{$t('new_request')}}
                        </b-button>
                    </div>
                    <template #title><span class="d-flex align-items-center">{{ $t('tuition_assistance_request') }}</span>
                    </template>
                    <b-table
                        :empty-text="this.$t('there_are_no_records')"
                        bordered
                        striped
                        responsive
                        :items="tuitionAssistanceRequest"
                        :fields="tuitionAssistanceRequestFields"
                        show-empty
                        class="mb-5 table-dropdown no-scrollbar border rounded"
                    >
                        <template #cell(actions)="row">
                            <div class="d-flex justify-content-end">
                                <b-dropdown
                                    right
                                    size="sm"
                                    variant="link"
                                    toggle-class="p-0"
                                    no-caret
                                    boundary="window"
                                >
                                    <template #button-content>
                                        <b-button
                                            size="sm"
                                            variant="link"
                                            class="btn-40 p-0 d-flex align-items-center justify-content-center"
                                        >
                                            <i class="ri-more-fill"></i>
                                        </b-button>
                                    </template>
                                    <b-dropdown-item
                                        v-if="checkPermission('tuitionassistancereevaluation_show')"
                                        link-class="d-flex align-items-center"
                                        @click="$router.push('/tuition/assistance/requests/detail/' + row.item.id)"
                                    >
                                        <i class="ri-edit-box-line mr-2"></i>{{ $t('detail') }}
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-if="checkPermission('tuitionassistancereevaluation_preevaluate')"
                                        link-class="d-flex align-items-center"
                                        @click="preEvaluateFormShow(row.item.id)"
                                    >
                                        <i class="ri-clipboard-line mr-2"></i>{{ $t('pre_evaluate') }}
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                        </template>
                    </b-table>
                </b-tab>
            </b-tabs>
            <CommonModal ref="preEvaluateFormModal" size="md" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ $t('pre_evaluate').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <pre-evaluate-form :formId="formId"
                                 @preEvaluateFormSuccess="preEvaluateFormSuccess"
                                 v-if="formProcess=='pre_evaluate'"/>
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header"
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile"

import CommonModal from "@/components/elements/CommonModal";
import {ValidationObserver, ValidationProvider} from "vee-validate";

import qs from "qs";
import TuitionAssistanceService from "@/services/TuitionAssistanceService";
import PreEvaluateForm from "@/modules/tuitionAssistanceRequest/pages/PreEvaluateForm.vue";

export default {
    components: {
        AppLayout,
        Header,
        HeaderMobile,

        CommonModal,
        ValidationProvider,
        ValidationObserver,
        PreEvaluateForm,
    },
    data() {
        return {
            tabIndex: 0,
            slots: null,
            tuitionAssistanceRequest: [],
            tuitionAssistanceRequestFields: [
                {key: 'actions', label: '', sortable: false, class: 'w-40'},
                {key: 'name', label: this.toUpperCase('name')},
                {key: 'surname', label: this.toUpperCase('surname')},
                {key: 'student_number', label: this.toUpperCase('student_number')},
                {key: 'program_name', label: this.toUpperCase('program_name')},
                {key: 'gpa', label: this.toUpperCase('gpa')},
                {key: 'status', label: this.toUpperCase('status')},
            ],
            formId: null,
            formProcess: null,
        }
    },
    metaInfo() {
        return {
            title: this.$t("tuition_assistance_re_evaluation_request")
        }
    },
    computed:{
        isStudent() {
            return this.$store.getters["auth/isStudent"];
        },
    },
    methods: {
        loadData() {
            const config = {
                params: {
                    filter: {},
                },
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            };

            TuitionAssistanceService.getAll(config)
                .then(response => {
                    this.tuitionAssistanceRequest = response.data.data;
                }).catch(e => {
                    this.showErrors(e);
                })

        },
        preEvaluateFormShow(id) {
            this.formId = id
            this.formProcess = 'pre_evaluate'
            this.$refs.preEvaluateFormModal.$refs.commonModal.show()
        },
        preEvaluateFormSuccess() {
            this.$refs.preEvaluateFormModal.$refs.commonModal.hide()
            this.loadData()
        },
    },
    created() {
        this.loadData();
        if (this.$route.params.tab) {
            this.tabIndex = parseInt(this.$route.params.tab)
        }
    },
}
</script>

